import { render, staticRenderFns } from "./UsageChallengeForm.vue?vue&type=template&id=6cb73064&scoped=true&"
import script from "./UsageChallengeForm.vue?vue&type=script&lang=js&"
export * from "./UsageChallengeForm.vue?vue&type=script&lang=js&"
import style0 from "./UsageChallengeForm.vue?vue&type=style&index=0&id=6cb73064&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb73064",
  null
  
)

export default component.exports